
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4f1t8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $61aa8de0ca8d98b5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $61aa8de0ca8d98b5$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Tous les sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analyses',
    'navigation.global-shortcuts.apps.assets': 'Actifs',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': "Hub d'entreprise",
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Objectifs',
    'navigation.global-shortcuts.apps.home': 'Accueil',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': "Jira\xa0Product\xa0Discovery",
    'navigation.global-shortcuts.apps.jira-service-management': "Jira\xa0Service\xa0Management",
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projets',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': "\xc9quipes",
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Fermer',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': "Site\xa0{name}",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(actuellement indisponible)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "Ouvrir l'ic\xf4ne de lien externe",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(chargement en cours)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(chargement en cours)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'ouvrir le menu',
    'navigation.global-shortcuts.sites': "Sites\xa0{productName}"
};

});


//# sourceMappingURL=fr.75127c30.js.map
